import { connect } from 'react-redux';
import { toggleMessageCenter } from 'header/system-message/containers/system-message-actions';
import MessageCenter from '../components/message-center-sidepanel';
import {
  dismissAllMessages,
  startPolling,
  fetchActionRequiredMessages,
} from './message-center-actions';

const mapStateToProps = state => ({
  messages: state.messageCenter.messages,
  error: state.messageCenter.error,
  isDismissing: state.messageCenter.isDismissing,
  messageCenterToggled: state.systemMessage.messageCenterToggled,
});

const mapDispatchToProps = {
  dismissAllMessages,
  toggleMessageCenter,
  startPolling,
  fetchActionRequiredMessages,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MessageCenter);
